import {createSlice} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import Team from '../../api/team'
import FormHelper from '../../utils/forms'
import Customer from '../../utils/customer'
import localStorageKeys from '../../utils/localStorageKeys'
import {getServices} from '../resources'

export const teamsSlice = createSlice({
    name: 'teams',
    initialState: {
        teams: [],
        selectedTeamId: Customer.getCurrentUserTeamId()
    },
    reducers: {
        setTeams: (state, {payload}) => {
            state.teams = payload
        },
        setSelectedTeamId: (state, {payload}) => {
            state.selectedTeamId = payload
            localStorage.setItem(localStorageKeys.TEAM_ID, payload)
        }
    }
})

export const {
    setTeams,
    setSelectedTeamId,
    setIsLoading
} = teamsSlice.actions

export default teamsSlice.reducer

export const getTeams = () => {
    return async(dispatch) => {
        try {
            const {data} = await Team.getTeams()
            dispatch(setTeams(data?.data?.teams?.map(item => {
                return {
                    ...item,
                    value: item?.team_id,
                    label: item?.name
                }
            })))
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}

export const addTeam = (values, setFieldError) => {
    return async() => {
        try {
            await Team.addTeam(values)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const updateTeam = (id, values, setFieldError) => {
    return async() => {
        try {
            await Team.updateTeam(id, values)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const deleteTeam = (teamId) => {
    return async(dispatch, getState) => {
        try {
            const {data} = await Team.deleteTeam(teamId)
            const teams = getState().teams.teams
            dispatch(setSelectedTeamId(teams?.[0]?.team_id))
            dispatch(getServices())
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        }
    }
}
